import { doc, getDoc } from 'firebase/firestore';
import { getDb } from '../firebase/firestore';
import { DEFAULT_PRICING, type PricingConfig } from './price';

/**
 * Barème de prix côté client — SOURCE UNIQUE partagée avec le serveur
 * (document Firestore `settings/pricing`, lisible publiquement). Le tunnel
 * affiche un prix INDICATIF calculé avec ce barème ; le prix facturé est
 * recalculé serveur avec le MÊME document. Repli sur `DEFAULT_PRICING` tant
 * que le doc n'est pas chargé, absent, ou si Firebase n'est pas configuré —
 * jamais de crash, jamais de prix nul.
 *
 * Le barème n'est plus dans le code : il s'édite depuis l'admin (Lot 1 PIM).
 */

const KEYS = Object.keys(DEFAULT_PRICING) as Array<keyof PricingConfig>;

/** Fusion tolérante d'un doc Firestore arbitraire sur le défaut. */
function mergeOverDefault(data: Record<string, unknown>): PricingConfig {
  const out = { ...DEFAULT_PRICING };
  for (const key of KEYS) {
    const v = Number(data[key]);
    if (Number.isFinite(v)) out[key] = v;
  }
  return out.marginBeadsHi > out.marginBeadsLo ? out : DEFAULT_PRICING;
}

let current = $state<PricingConfig>(DEFAULT_PRICING);
let loadPromise: Promise<void> | null = null;

async function doLoad(): Promise<void> {
  const db = getDb();
  if (!db) return; // non configuré (dev/CI) → on garde DEFAULT
  try {
    const snap = await getDoc(doc(db, 'settings', 'pricing'));
    if (snap.exists()) current = mergeOverDefault(snap.data() ?? {});
  } catch (err) {
    console.error('[pricing] barème non chargé, repli DEFAULT :', err);
  }
}

export const pricingConfig = {
  /** Barème courant (réactif). Repli DEFAULT_PRICING avant chargement. */
  get current(): PricingConfig {
    return current;
  },
  /** Charge le barème une seule fois (idempotent). À appeler tôt (tunnel/admin). */
  load(): Promise<void> {
    if (loadPromise === null) loadPromise = doLoad();
    return loadPromise;
  },
  /** Met à jour le barème en mémoire après un enregistrement admin. */
  set(cfg: PricingConfig): void {
    current = cfg;
  },
};
